export function timelineToXML(rows) {
    const XML = require("xml");
    const uniqueCodes = [];
    const instancesArray = [];

    [...(rows || [])]
        .sort((a, b) => {
            if (a.index > b.index) return 1;
            if (a.index < b.index) return -1;
            return 0;
        })
        .forEach((row) => {
            if (!uniqueCodes.includes(row.name)) {
                uniqueCodes.push(row.name);
            }

            const instance = [
                { ID: row.index + 1 },
                { start: row.inTime },
                { end: row.outTime },
                { code: row.name },
            ];

            if (row.stars > 0) {
                instance.push({ stars: row.stars });
            }

            (row.labels || []).forEach((label) => {
                const labelArray = [{ text: label.text }];

                if (label.group) {
                    labelArray.push({ group: label.group });
                }

                if (label.start) {
                    labelArray.push({ start: label.start });
                }

                instance.push({ label: labelArray });
            });

            (row.notes || []).forEach((note) => {
                instance.push({ free_text: note });
            });

            instancesArray.push({ instance });
        });

    const rowsArray = uniqueCodes.map((code) => ({
        row: [
            { code },
            { R: 0 },
            { G: 39321 },
            { B: 13107 },
            { red: 0.0 },
            { green: 0.6 },
            { blue: 0.2 },
            { fontRed: 1.0 },
            { fontGreen: 1.0 },
            { fontBlue: 1.0 },
        ],
    }));

    return XML(
        [
            {
                file: [
                    { ALL_INSTANCES: instancesArray },
                    { ROWS: rowsArray },
                ],
            },
        ],
        true,
    );
}

export function exportTimelineToXML(rows, filename) {
    const output = timelineToXML(rows);
    const blob = new Blob([output], { type: "text/xml" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.download = `${filename}.xml`;
    link.href = url;
    link.click();

    window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
